import { DtoBase } from "../DtoBase";
import { UserDto } from "./UserDto";
import { UserPermissions } from "./UserPermissionsCache";
import { SessionDto } from "../Session/SessionDto";


export enum LoginResultCode {
	None,
	Succeeded,
	Failed,
	Redirect,
}


export class LoginResultDto extends DtoBase {

	public Code: LoginResultCode;
	public User: UserDto;
	public Session: SessionDto;
	public UserPermissions: UserPermissions;
	public RedirectUrl: string;

	constructor(code?: LoginResultCode) {
		super();

		this.Code = ((code === undefined) ? LoginResultCode.None : code);
		this.User = null;
		this.Session = null;
		this.UserPermissions = null;
		this.RedirectUrl = "";
	}

	public get HasCode(): boolean {
		return (this.Code !== LoginResultCode.None);
	}

	public get HasUser(): boolean {
		return !!this.User;
	}

	public get HasSession(): boolean {
		return !!this.Session;
	}

	public get HasUserPermissions(): boolean {
		return !!this.UserPermissions;
	}

	public get HasRedirectUrl(): boolean {
		return !!this.RedirectUrl;
	}

	public Write(obj: any, context: any): void {

		obj.login_result = {};
		obj = obj.login_result;

		super.Write(obj, context);

		if (this.HasCode) {
			obj.code = LoginResultCode[this.Code];
		}

		if (this.HasUser) {
			this.User.Write(obj, context);
		}

		if (this.HasSession) {
			this.Session.Write(obj, context);
		}

		if (this.HasUserPermissions) {
			this.UserPermissions.Write(obj, context);
		}

		if (this.HasRedirectUrl) {
			obj.redirect_url = this.RedirectUrl;
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.login_result)
			throw new Error();
		obj = obj.login_result;

		super.Read(obj, context);

		if (obj.code !== undefined) {
			this.Code = LoginResultCode[<string>obj.code];
		}

		if (obj.user !== undefined) {
			this.User = new UserDto();
			this.User.Read(obj, context);
		}

		if (obj.session != undefined) {
			this.Session = new SessionDto();
			this.Session.Read(obj, context);
		}

		if (obj.user_permissions !== undefined) {
			this.UserPermissions = new UserPermissions();
			this.UserPermissions.Read(obj, context);
		}

		if (obj.redirect_url !== undefined) {
			this.RedirectUrl = obj.redirect_url;
		}
	}

}